import { environment } from '®environments/environment';

import { AppConfig } from './app-config';
import { ListReviewAndPublishMode } from './list-review-and-publish-mode';
import { PerlegoIntegrationMode } from './perlego-integration-mode';

/**
 * Fake app config for local development
 **/
export class AppConfigLocalDev extends AppConfig {
  apiEndpoint = environment.proxy
    ? 'http://shipshape.talis.local:4200/api/3'
    : 'http://rl.talis.local/3';
  beta = '/beta.html';
  error = '/error.html';
  isEmbeddedMode = false;
  ltiRelinkUrl = undefined;
  personaEndpoint = environment.proxy
    ? 'http://shipshape.talis.local:4200/persona/2'
    : 'https://persona.talis.local/2';
  talisLoginProvider = 'talis-google';
  // public key: https://dashboard.outbound.io/dashboard/settings/environments
  zendeskOutboundKey = 'CHANGE_ME';
  tenant = {
    anonymousAccessToken: undefined,
    conceptBaseUri: 'http://life.ac.uk',
    featureFlags: {
      isAddFromWorksEnabled: true,
      isDigitisationWorkflowEnabled: true,
      isListEditEnabled: true,
      isMisDashboardEnabled: true,
      isReportBrokenLinkEnabled: true,
      isShipshapeTenancyDefault: true,
      reviewWorkflow: ListReviewAndPublishMode.REVIEW_AND_PUBLISH,
    },
    library: {
      hideDoiLinks: false,
    },
    hierarchy: {
      isHierarchyUpdateEnabled: true,
    },
    perlego: {
      integrationMode: PerlegoIntegrationMode.STANDARD,
      partnerId: 619220,
    },
    httpsBaseUri: environment.proxy
      ? 'http://shipshape.talis.local:4200'
      : 'https://life.ac.uk',
    loginProvider: 'trapdoor',
    name: 'University of Life',
    roleMapping: {
      admin: [
        'admin-branding',
        'request-rollover',
        'upload-hierarchy',
        'resource-metadata-refresh',
        'grant-this-role',
        'access-keys',
        'lti-debug',
      ],
      libraryacquisitions: [
        'view-acquisitions',
        'receive-new-review-requests-by-email',
      ],
      listcreator: ['create-list'],
      listpub: [
        'edit-list',
        'publish-list',
        'grant-this-role',
        'list-access-control',
        'request-digitisation',
        'request-review',
        'archive-list',
        'view-reports',
        'attach-list-to-node',
        'assign-license',
        'delete-list',
      ],
      publishonly: [
        'publish-list',
        'grant-this-role',
        'list-access-control',
        'request-digitisation',
        'request-review',
        'archive-list',
        'view-reports',
        'attach-list-to-node',
        'assign-license',
      ],
      nodeeditor: ['edit-node', 'attach-list-to-node', 'grant-this-role'],
      roleadmin: [
        'grant-any-role',
        'idp-migration',
        'request-rollover',
        'resource-metadata-refresh',
      ],
      v2listadmin: ['v2-configure-list-beta', 'v2-list-view'],
      v2listedit: ['v2-list-edit'],
      'tdc:app:access': ['manage-player-resources'],
    },
    roleCodesByRoleId: {
      'list-publisher': 'listpub',
    },
    shortCode: 'life',
    v2DashboardEnabled: undefined,
    reviewsUrl: 'http://critic.talis.local/life/reviews',
  };
}
